
import { Group, Object3D, PerspectiveCamera, } from "three";
import { yAxis } from "./utils";

export default class Pivot {
    public instance!: Group;
    private perspectiveCamera: PerspectiveCamera;

    constructor(perspectiveCamera: PerspectiveCamera) {
        this.instance = new Group();
        this.perspectiveCamera = perspectiveCamera;
    }

    public addToPivot = (obj: Object3D) =>
        this.instance.add(obj)

    public rotatePivotToCamera = () =>
        this.instance.setRotationFromAxisAngle(yAxis, this.perspectiveCamera.rotation.y);
}
